module.exports = __webpack_public_path__ + "static/media/airbnb.d8b7fbac.png";